import { cn } from "lib/utils"

function Skeleton({
  className,
  ariaLabel = "Loading",
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { ariaLabel?: string }) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-slate-900/10 dark:bg-slate-50/10",
        className
      )}
      {...props}
      role="status"
      aria-busy="true"
      aria-label={ariaLabel}
    />
  )
}

export { Skeleton }
